import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, BoxProps, Button, HStack } from '@bonusly/design-system';

import { useCelebrationDisplay } from '../hooks/use-celebration-display';
import { useTrackCelebrations } from '../hooks/use-track-celebrations';
import { CelebrationType } from '../types';

export interface CelebrationLinkProps extends BoxProps {
	celebrationDate?: string;
	celebrationId: string;
	celebrationType: CelebrationType;
}
export const CelebrationLink: FC<CelebrationLinkProps> = ({ celebrationDate, celebrationId, celebrationType, ...rest }) => {
	const navigate = useNavigate();
	const { trackUserPopoverCelebrationLinkClick } = useTrackCelebrations();

	const { emoji, text } = useCelebrationDisplay(celebrationType, celebrationDate);

	return (
		<HStack alignItems="center" spacing={1} {...rest}>
			<Box as="span" fontSize={50} flexShrink={0} lineHeight={1}>
				{emoji}
			</Box>
			<Button
				colorScheme="primary"
				data-testid={`celebration-link-${celebrationId}`}
				onClick={() => {
					trackUserPopoverCelebrationLinkClick({ celebrationType });
					navigate(`/bonuses/${celebrationId}`);
				}}
				size="xs"
				variant="link"
			>
				{text}
			</Button>
		</HStack>
	);
};
